export default {
  namespaced: true,
  state: {
    
    active: false,

  },
  mutations: {

    setActive(state, flag) {
      state.active = flag;
    }
  },
  actions: {


    toggleMinimize({ rootGetters, getters, dispatch }) {
      dispatch('user-settings/setItem', {
        type: 'local',
        item: {
          value: !getters.minimized,
          key: 'sidebar-minimized',
        }
      }, { root: true })
    },


    minimize({ rootGetters, dispatch }) {
      dispatch('user-settings/setItem', {
        type: 'local',
        item: {
          value: true,
          key: 'sidebar-minimized',
        }
      }, { root: true })
    },


    maximize({ getters, dispatch }) {
      dispatch('user-settings/setItem', {
        type: 'local',
        item: {
          value: false,
          key: 'sidebar-minimized',
        }
      }, { root: true })
    },


    deactivate({ getters, dispatch, commit }) {
      commit('setActive', false);
    },

    activate({ getters, dispatch, commit }) {
      commit('setActive', true);
    },


    toggleActive({ getters, dispatch, commit }) {
      commit('setActive', !getters.active);
    },
  },
  getters: {


    minimized(state, getters, rootState, rootGetters) {
      return !!rootGetters['user-settings/data']['sidebar-minimized'];
    },


    active(state, getters, rootState, rootGetters) {
      return state.active;
    },
  }
}
